import { createRouter, createWebHistory } from '@ionic/vue-router'
import { authMiddleware } from '@/router/middleware/auth.middleware'
import { myAreaMiddleware } from '@/router/middleware/myArea.middleware'
import { adminMiddleware } from '@/router/middleware/admin.middleware'
import { shiftMiddleware } from '@/router/middleware/shift.middleware'
import { routes } from '@/router/routes'
import { useRoute } from 'vue-router'
import type { areas } from '@/router/areas'
import type { DeviceType } from '@/api/client'
import type { UseBackButtonResult } from '@ionic/vue'
import { useBackButton } from '@ionic/vue'
import type { BarBackgroundStyle } from '@/composables/useNativeStyle'

declare module 'vue-router' {
  interface RouteMeta {
    area?: areas
    device_type?: DeviceType[]
    isStateful?: boolean
    showHeader?: boolean
    showFooter?: boolean
    showProfilePicture?: boolean
    showPill?: boolean
    showTime?: boolean
    scrollable?: boolean
    showGradient?: boolean
    headerTitle?: string
    showBackButton?: boolean
    disableNativeBackButton?: boolean
    statusBarBackgroundStyle?: BarBackgroundStyle
    navigationBarBackgroundStyle?: BarBackgroundStyle
    hyphens?: 'auto' | 'manual' | 'none'
  }
}

const router = createRouter({
  history: createWebHistory('app'),
  routes: routes,
})

const middleware = [
  authMiddleware,
  myAreaMiddleware,
  adminMiddleware,
  shiftMiddleware,
]
let backButtonOverride: UseBackButtonResult | null = null

router.beforeEach((to, from) => {
  if (to.meta.disableNativeBackButton) {
    console.log('disabling back button')
    backButtonOverride = useBackButton(200, () => {
      console.log('overriding back button behaviour')
    })
  } else if (backButtonOverride) {
    console.log('enabling back button')
    backButtonOverride.unregister()
    backButtonOverride = null
    useBackButton(200, () => {
      console.log('enabling back button behaviour')
      router.back()
    })
  }
  return middleware.every((m) => m(to, from))
})

const route = useRoute()

export { router as default, route }
